/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import FormField from "../FormField";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import Map from "../../../components/Map";
import Card from "@mui/material/Card";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

function Address({ formData }) {
  const { formField, values, errors, touched, setFieldValue } = formData;
  const { address, city, state, lat, lon } = formField;
  const { address: addressV, city: cityV, state: stateV, lat: latV, lon: lonV } = values;

  const center = {
    lat: latV,
    lng: lonV
  };

  return (
    <Card>
      <MDBox p={3}>
        <MDTypography variant="h5" fontWeight="bold">
          Address
        </MDTypography>
        <MDBox mt={1.625}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormField
                type={address.type}
                label={address.label}
                name={address.name}
                value={addressV}
                placeholder={address.placeholder}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <FormField
                type={city.type}
                label={city.label}
                name={city.name}
                value={cityV}
                placeholder={city.placeholder}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormField
                type={state.type}
                label={state.label}
                name={state.name}
                value={stateV}
                placeholder={state.placeholder}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} alignContent="center">
              <MDTypography variant="h5" fontWeight="bold">
                Click to pin current location
              </MDTypography>
            </Grid>
            <Grid item xs={12} alignContent="center">
              <Map center={center} eventName={values.name} setFieldValue={setFieldValue} editable={true}
                   style={{ height: "60vh", width: "110vh" }} isStartAtPoint={true}/>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </Card>
  );
}

// typechecking props for Address
Address.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
};

export default Address;
